const validateInstitutionStep = (form) => {
  const hasRequiredValues = form.currentInstitution.parentId && form.currentInstitution.name;
  return hasRequiredValues ? {} : {currentInstitution: 'Missing required fields'};
};

export default validateInstitutionStep;
